<template>
  <div class="flex flex-col gap-2 mini-pp">
    <sc-link :field="fields.internalLink" class="block w-full">
      <div class="gold-border-wrapper p-[3px]!">
          <div class="rounded-xl relative w-full h-[100px] flex items-center justify-center overflow-hidden">
              <!-- blurred background image -->
              <sc-image :media="fields.image"
                        class="absolute inset-0 w-full h-full object-cover filter blur-[1px] z-0" />

              <!-- translucent white gradient overlay from left -->
              <div class="absolute inset-0 z-10 pointer-events-none banner-gradient"
                   aria-hidden="true" />
              <div class="flex h-full w-full p-4 justify-left items-center">
                  <h3 class="text-base font-bold relative z-12 text-xl"><sc-text :field="fields.text" /></h3>
              </div>
              
          </div>
      </div>
    </sc-link>

    <div class="flex gap-2 items-start">
      <div class="px-2">
          <p class="text-base font-bold"><sc-text :field="fields.strapline" /></p>
      </div>
    </div>
  </div>
</template>

<script>
import { Image as ScImage, Text as ScText, Link as ScLink } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'MiniPagePreview',
  props: {
    rendering: {
      type: Object,
      required: true,
    },
  },
  components: {
    'sc-image': ScImage,
    'sc-text': ScText,
    'sc-link': ScLink,
  },
  computed: {
    fields() {
      // rendering.fields are populated from route YAML (disconnected)
      // or from Layout Service (integrated)
      return this.rendering?.fields || {};
    },
    imageUrl() {
      const img = this.fields?.image || {};
      // try common shapes used by disconnected/layout service
      return img.src || (img.value && img.value.src) || (img.fields && img.fields.src) || '';
    },
  },
};
</script>
<style scoped>
.banner-gradient {
  background:
    linear-gradient(97deg, rgba(255, 255, 255, 0.6) 0.13%, rgba(255, 255, 255, 0) 64.91%),
    rgba(1, 56, 141, 0.2);
  background-repeat: no-repeat;
  background-size: cover;
}

.title {
  text-shadow:
    0 0 8px rgba(1, 17, 47, 0.5),
    0 0 16px #01112f;
}
</style>
